import React, { useEffect, useRef, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Chat from "../chat/chat";
import Questionnaire from "../questionnaire/questionnaire";
import Modal from "../modal/Modal";
import TermsPopup from "../termsPopup/termsPopup";
import i18n from "../../i18n";
import { LanguageSelection } from "../LanguageSelection/LanguageSelection";
import { tWithKeyAttr as t } from "../../i18nHelper";
import {
  addKeysToAllTranslatedElements,
  enableTranslationMode,
} from "../../translationMode";

window.enableTranslationMode = enableTranslationMode;

function App() {
  useEffect(() => {
    if (i18n.isInitialized) {
      addKeysToAllTranslatedElements();
    } else {
      i18n.on("initialized", () => {
        addKeysToAllTranslatedElements();
      });
    }
  }, []);
  const [openTermsModal, setOpenTermsModal] = useState(false);
  const searchParams = new URLSearchParams(window.location.search);
  const uid = searchParams.get("bpreven");
  const questionnaire = searchParams.get("q");

  useEffect(() => {
    const dir = i18n.language === "he"|| i18n.language === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", i18n.language);
  }, [i18n.language]);

  return (
    <>
      <LanguageSelection></LanguageSelection>
      <Router >
        <Routes>
          <Route
            path={"/:name?/:symbol?"}
            element={
              <section className={`section`}>
                {uid && !questionnaire ? (
                  <Questionnaire
                    link={`?bpreven=${uid}&q=26`}
                  />
                ) : (
                  <>
                    <h1 className={"section__title"}>{t("VENCHI_FOR_YOU")}</h1>
                    <button
                      onClick={() => setOpenTermsModal(true)}
                      className={"section__link"}
                    >
                      {t('CONDITIONS_IN_WEBSITE')}</button>
                    <Chat u={uid} />
                  </>
                )}
                {openTermsModal && (
                  <Modal onClose={() => setOpenTermsModal(false)}>
                    <TermsPopup onClose={() => setOpenTermsModal(false)} />
                  </Modal>
                )}
              </section>
            }
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;
declare global {
  interface Window {
    enableTranslationMode: (isEnabled: boolean) => void;
  }
}
